export default __webpack_public_path__ + "static/media/1.751df58b.png";